import { animate, style, transition, trigger } from "@angular/animations";
import { Component, DestroyRef, inject } from "@angular/core";
import { Capacitor } from "@capacitor/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

import { AktuelBrugerObserver, Rolle } from "@e-forsyning/common/bruger";

@Component({
    selector: "app-servicepro-app-referrer",
    imports: [],
    templateUrl: "./servicepro-app-referrer.html",
    styleUrl: "./servicepro-app-referrer.scss",
    animations: [
        trigger("slideAnimation", [
            transition(":enter", [style({ transform: "translateY(100%)" }), animate("400ms ease-out")]),
            transition(":leave", [animate("400ms ease-in", style({ transform: "translateY(100%)" }))])
        ])
    ]
})
export class ServiceproAppReferrer {
    public isVisible: boolean = true;
    public isMobile: boolean = false;
    public isFofBruger: boolean = false;

    private readonly destroyRef = inject(DestroyRef);
    private readonly aktuelBrugerObserver = inject(AktuelBrugerObserver);

    ngOnAfterViewInit(): void {
        this.detectPlatform();
        this.aktuelBrugerObserver.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((bruger) => {
            this.isFofBruger = !!bruger && Rolle.erFofBruger(bruger.rolle);
        });
    }

    public close(): void {
        this.isVisible = false;
    }

    public openApp(): void {
        const isAndroid = /Android/i.test(navigator.userAgent);
        const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

        if (isAndroid) {
            window.location.href = "https://play.google.com/store/apps/details?id=dk.softvaerket.technician";
        } else if (isIOS) {
            window.location.href = "https://apps.apple.com/dk/app/servicepro/id6778028022";
        } else {
            window.location.href = "http://forsyningservicepro.dk/";
        }
    }

    private detectPlatform(): void {
        if (Capacitor?.isNativePlatform()) {
            this.isMobile = true;
        } else {
            this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        }
    }
}
